var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSend(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 24,
    fill: "#413C6D"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M29.5202 11.9467L17.4802 15.9467C9.38682 18.6534 9.38682 23.0667 17.4802 25.7601L21.0535 26.9467L22.2402 30.5201C24.9335 38.6134 29.3602 38.6134 32.0535 30.5201L36.0668 18.4934C37.8535 13.0934 34.9202 10.1467 29.5202 11.9467ZM29.9468 19.1201L24.8802 24.2134C24.6802 24.4134 24.4268 24.5067 24.1735 24.5067C23.9202 24.5067 23.6668 24.4134 23.4668 24.2134C23.0802 23.8267 23.0802 23.1867 23.4668 22.8001L28.5335 17.7067C28.9202 17.3201 29.5602 17.3201 29.9468 17.7067C30.3335 18.0934 30.3335 18.7334 29.9468 19.1201Z",
    fill: "white"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSend);
export default __webpack_public_path__ + "static/media/send.fb0a9da1e3719531f9bd1d390681003f.svg";
export { ForwardRef as ReactComponent };